import { ComponentType } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';

export interface ProtectedRouteProps {
  component: ComponentType<any>;
  path: string;
}

const ProtectedRoute = ({ component: Component, path }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();

  return (
    <Route
      path={path}
      render={(props: RouteProps) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              search: `?redirect=${encodeURIComponent(props.location?.pathname || path)}`,
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;